/**
 * 配列内の項目のカウント数を足し合わせる
 *
 * @param 配列
 *
 * @return 数値
 */
/* eslint-disable */
const sum = function (arr, fn) {
  if (fn) {
    return sum(arr.map(fn))
  } else {
    return arr.reduce(function (prev, current, i, arr) {
      return prev + current
    })
  }
}

export default sum



// WEBPACK FOOTER //
// ./src/functions/sum.js